export default __webpack_public_path__ + "static/yugensys-50e1688cb08eb859950b1c9752c332d3.svg";